<template>
  <div>
    <CreateCampaign
      v-if="dataReady && isEmpty(campaigns) || createNew"
      @update="selfUpdate"
    />
    <CampaignStatus
      v-else-if="!isEmpty(campaigns)"
      @update="createNew = true"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '@/store'
import CreateCampaign from './dashboard/CreateCampaign.vue'
import CampaignStatus from './dashboard/CampaignStatus.vue'

export default {
  components: {
    CreateCampaign,
    CampaignStatus,
  },
  data() {
    return {
      createNew: false,
      dataReady: false,
    }
  },
  computed: {
    ...mapGetters(['user', 'campaigns']),
  },
  async mounted() {
    await this.initUser().then(async () => {
      await this.initCampaigns().then(() => {
        this.dataReady = true
      })
    })
  },
  methods: {
    initUser() {
      return new Promise((resolve, reject) => {
        if (!this.user) {
          store.dispatch('fetchUserProfile').then(() => {
            resolve()
          }).catch(() => {
            reject()
          })
        } else {
          resolve()
        }
      })
    },
    initCampaigns() {
      return new Promise((resolve, reject) => {
        if (this.user) {
          store.dispatch('fetchCampaigns', { uid: this.user.uid }).then(() => {
            resolve()
          }).catch(() => {
            reject()
          })
        } else if (!this.user) {
          reject()
        } else {
          resolve()
        }
      })
    },
    async selfUpdate() {
      await this.initUser().then(async () => {
        await this.initCampaigns().then(() => {
          this.dataReady = true
        })
      })
      this.$forceUpdate()
    },
  },
}
</script>

<style>

</style>
